import { useSelector } from 'react-redux'
import { Panel } from '../../../common/panel'
import { selectBranchIds } from '../store/slice'
import { downloadBranch } from '../store/thunk'
import { BranchTable } from './BranchTable'

export const Branches = ({ organizationId }) => {
  const ids = useSelector(selectBranchIds)

  return (
    <Panel
      id="branches"
      isI18n
      label="companyAnalysis.ownershipAndGroup.BRANCHES"
      downloadCsv={{
        disabled: !ids.length,
        downloadFunc: () => downloadBranch({ OrganizationId: organizationId }),
      }}
    >
      <BranchTable />
    </Panel>
  )
}
